import React from "react";
import {
  Image,
  IImageProps,
  Icon,
  getCurrentViewport,
  IMAGE_RATIO_1X1,
  IMAGE_RATIO_16X9,
  IMAGE_RATIO_3X4,
  IMAGE_RATIO_4X3,
  IMAGE_RATIO_2X1,
  IMAGE_RATIO_6X1,
  IMAGE_RATIO_3X1,
  IMAGE_RATIO_3X2,
  IMAGE_RATIO_5X2,
  ImageRatio
} from "fr-ito-web-react/react/esm";

export interface ECImageRatioMap {
  IMAGE_RATIO_1X1: ImageRatio;
  IMAGE_RATIO_16X9: ImageRatio;
  IMAGE_RATIO_3X4: ImageRatio;
  IMAGE_RATIO_4X3: ImageRatio;
  IMAGE_RATIO_2X1: ImageRatio;
  IMAGE_RATIO_6X1: ImageRatio;
  IMAGE_RATIO_3X1: ImageRatio;
  IMAGE_RATIO_3X2: ImageRatio;
  IMAGE_RATIO_5X2: ImageRatio;
}

export const ECImageRatio: ECImageRatioMap = {
  IMAGE_RATIO_1X1,
  IMAGE_RATIO_16X9,
  IMAGE_RATIO_3X4,
  IMAGE_RATIO_4X3,
  IMAGE_RATIO_2X1,
  IMAGE_RATIO_6X1,
  IMAGE_RATIO_3X1,
  IMAGE_RATIO_3X2,
  IMAGE_RATIO_5X2
};

export type ECImageProps = {
  smallMediumImageUrl?: string;
  smallMediumImageRatio?: ImageRatio;
  largeImageUrl?: string;
  largeImageRatio?: ImageRatio;
} & IImageProps;

export const generateImgConfig = (props: ECImageProps) => {
  const {
    smallMediumImageRatio,
    largeImageUrl,
    largeImageRatio,
    smallMediumImageUrl,
    src,
    ratio
  } = props;
  const viewportSize = getCurrentViewport();
  let imgSrc = "";
  let imgRatio;
  if (viewportSize === "sm" || viewportSize === "md") {
    imgSrc = smallMediumImageUrl || largeImageUrl || src || "";
    imgRatio = smallMediumImageRatio || ratio;
  } else {
    imgSrc = largeImageUrl || smallMediumImageUrl || src || "";
    imgRatio = largeImageRatio || ratio;
  }
  return {
    imgSrc,
    imgRatio
  };
};

export const NewImage: React.FC<ECImageProps> = (props: ECImageProps) => {
  const imageRef = React.useRef<HTMLImageElement>(null);
  const errorIcon = (
    <Icon name="attention" designTokens={{ colorToken: "ito-gray300" }} />
  );
  const { imgSrc, imgRatio } = generateImgConfig(props);
  // The UI kit consumes fetchPriority without forwarding it to the native img.
  const nativeFetchPriority = props.fetchPriority
    ? { fetchpriority: props.fetchPriority }
    : {};
  return (
    <Image
      ref={imageRef}
      // This wrapper intentionally forwards the full IImageProps API to Image.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...nativeFetchPriority}
      src={imgSrc}
      ratio={imgRatio}
      errorIcon={errorIcon}
    />
  );
};
